<div class="page-title" [class.page-title--empty]="!hasTitle && !back">
  <div class="page-title-heading-row">
    @if (hasTitle) {
      <h2 class="doc-title">{{ title }}</h2>
    }
    <ng-content select="[doc-common-title-trailing]"></ng-content>
  </div>

  @if (back) {
    <div class="page-back text-warning" (click)="redirectForm()">
      <span class="back-text">
        <a>{{ 'General.Back' | translate }}</a>
      </span>
      <a><i class="pi pi-arrow_back"></i></a>
    </div>
  }
</div>

@if (showBreadcrumb && breadcrumbs?.length) {
  <div class="document-breadcrumb" [class.document-breadcrumb--standalone]="!hasTitle && !back">
    @for (item of breadcrumbs; track item; let last = $last; let first = $first) {
      @if (!first) {
        <span class="breadcrumb-separator"><i class="pi pi-chevron-right"></i></span>
      }
      <a
        [routerLink]="canNavigateBreadcrumb(item, last) ? item.link : null"
        [queryParams]="item.queryParams"
        class="flex align-items-center gap-2 breadcrumb-link"
        [class.active-breadcrumb]="last"
        [class.pointer-events-none]="!canNavigateBreadcrumb(item, last)"
        [attr.title]="getFullBreadcrumbLabel(item?.labelKey ? (item.labelKey | translate) : item?.label)"
        >
        @if (item.icon === 'home') {
          <app-dynamic-icon
            name="custom:home"
            color="#9ca3af"
            size="16px">
          </app-dynamic-icon>
        }
        <!-- Prefer labelKey so first AR/RTL switch updates immediately after translations load -->
        <span class="breadcrumb-label">{{ formatBreadcrumbLabel(item?.labelKey ? (item.labelKey | translate) : item?.label) }}</span>
      </a>
    }
  </div>
}
